const TOPICS_LIST = [
  { label: '#4K超清蓝光', hot: true },
  { label: '#国产剧推荐', hot: true },
  { label: '#不缓冲秒播', hot: true },
  { label: '#韩剧精选', hot: false },
  { label: '#大屏TV体验', hot: true },
  { label: '#电影大片', hot: false },
  { label: '#综艺热播', hot: false },
  { label: '#动漫新番', hot: true },
  { label: '#纪录片精选', hot: false },
  { label: '#每日更新', hot: true },
  { label: '#免费在线', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-50">
            热门话题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            大家都在讨论的影视话题，加入交流发现更多好内容
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-2 md:gap-3 max-w-4xl mx-auto">
          {TOPICS_LIST.map((topic) => (
            <a
              key={topic.label}
              href="#index"
              className={`group inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium border transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-500/10 text-primary-400 border-primary-500/25 hover:bg-primary-500/20'
                  : 'bg-background-50 text-foreground-400 border-background-300/20 hover:text-foreground-200 hover:border-background-300/40'
              }`}
            >
              {topic.label}
              {topic.hot && (
                <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
                  <i className="ri-fire-line text-accent-400 text-xs"></i>
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}